import styled from "styled-components";

export const container = styled.div`
    background: #F6F5FA;
    padding: 1.5rem 2rem;
    border-radius: 20px;
    width: 32rem;
    grid-area: main;

    h2{
        font: 600 1.5rem 'Poppins', sans-serif;
        color: #545455;
    }

    div{
        display: flex;
        justify-content: space-between;
        align-items: center;
        

        p{
            font: 400 1.3rem 'Poppins', sans-serif;
            color: #F58B1E;

            span{
                font: 600 2rem 'Poppins', sans-serif;
                color: inherit;
            }
        }

        button{
            background: #F58B1E;
            font-size: 1.7rem;
            color: #fff;
            border-radius: 5px;
            display: flex;
            align-items: center;
            padding: .7rem 1rem;
            justify-content: center;
            box-shadow: 0 5px 10px .5px #f5891e52;
            margin: 2rem 0 ;
            letter-spacing: .3px;
            

            span{
                font: 500 1.2rem 'Poppins', sans-serif;
                margin: 0 .5rem;
                color: inherit;
            }
        }
    }

    span{
        font: 400 1.2rem 'Poppins', sans-serif;
        color:#b8b4ccc8;
    }

    @media (max-width: 576px){
        width: 100%;
        padding: 1.5rem 2rem;
        border-radius: 0;

        h2{
            font-size: 2rem;
        }

        div{
            p{
                font-size: 1.5rem;
                span{
                    font-size: 2rem;
                }
            }

            button{
                padding: .5rem .8rem;
                width: 15rem;
                font-size: 2rem;

                span{
                    font-size: 1.3rem;
                    width: 7rem;
                }
            }
        }
        span{
            font-size: 1.3rem;
        }
    }

    
    @media (min-width: 576px) and (max-width: 767px){
        width: 32vw;
        padding: 1.2rem 1.2rem;

        h2{
            font-size: 1.1rem;
        }

        div{
            p{
                font-size: .8rem;
                span{
                    font-size: 1.4rem;
                }
            }

            button{
                padding: .4rem .7rem;
                width: 8.5rem;
                font-size: 1.1rem;

                span{
                    font-size: .9rem;
                    width: 4rem;
                }
            }
        }
        span{
            font-size: .9rem;
        }
    }


    @media (min-width: 767.98px) and (max-width: 999px){
        width: 30vw;
        padding: 1.4rem 1.4rem;

        h2{
            font-size: 1.2rem;
        }

        div{
            p{
                font-size: .9rem;
                span{
                    font-size: 1.6rem;
                }
            }

            button{
                padding: .4rem .7rem;
                width: 9rem;
                font-size: 1.2rem;

                span{
                    font-size: .9rem;
                    width: 4rem;
                }
            }
        }
        span{
            font-size: .9rem;
        }
        
    }

    @media (min-width: 999.98px) and (max-width: 1250px){
        width: 22vw;
        padding: 1.4rem 1.4rem;

        h2{
            font-size: 1.2rem;
        }

        div{
            p{
                font-size: .9rem;
                span{
                    font-size: 1.6rem;
                }
            }

            button{
                padding: .4rem .7rem;
                width: 9rem;
                font-size: 1.2rem;

                span{
                    font-size: .9rem;
                    width: 4.9vw;
                }
            }
        }
        span{
            font-size: .9rem;
        }
    }
        

`